import { useAction, useAtom } from '@reatom/npm-react'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { css } from 'styled-components'

import { Redacted } from '@blade/std-lib'
import { Button } from '@blade/ui-kit'
import { isPasswordValid } from '@root/entities/auth/constants'
import { InputPassword, mediaMaxTablet } from '@root/shared/ui-kit'

import { UpdatePasswordHeading } from './update-password-heading'

import type { LocalPasswordEditFlowReatom } from '../atoms/update-local-password'
import type { PasswordEditFlowReatom } from '../atoms/update-password'

type Props = {
  model: PasswordEditFlowReatom | LocalPasswordEditFlowReatom
}

export const UpdatePasswordCurrent: React.FC<Props> = ({ model }) => {
  const { t } = useTranslation()

  const checkCurrentPassword = useAction(model.checkCurrentPasswordAction)
  const [requestState] = useAtom(model.checkPasswordStateAtom)

  const { formState, control, handleSubmit } = useForm({
    defaultValues: {
      password: '',
    },
    mode: 'all',
  })

  const handleSubmitInternal = handleSubmit((values) => {
    checkCurrentPassword(Redacted.make(values.password))
  })

  return (
    <Root>
      <UpdatePasswordHeading title={t('settings.password.title-current')} />

      <Form noValidate onSubmit={handleSubmitInternal}>
        <Controller
          name="password"
          control={control}
          rules={{
            validate: {
              isPasswordValid,
            },
          }}
          render={({ field }) => (
            <InputPasswordCurrent
              {...field}
              autoCorrect="off"
              spellCheck={false}
              autoCapitalize="off"
              autoComplete="off"
              size="m"
            />
          )}
        />
        <ButtonContinue
          disabled={!formState.isValid}
          busy={requestState.loading}
          variant="soft"
          size="xs"
          type="submit"
          radius="rounded"
        >
          {t('common.continue')}
        </ButtonContinue>
      </Form>
    </Root>
  )
}

const Root = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
`

const Form = styled.form`
  display: grid;
  grid-template-rows: 1fr auto;
  gap: 20px;
`

const ButtonContinue = styled(Button)`
  place-self: center;
`

const InputPasswordCurrent = styled(InputPassword)`
  place-self: center;

  ${mediaMaxTablet(css`
    place-self: unset;
    padding-inline: 20px;
  `)}
`
